import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-mc-icon',
  templateUrl: './shopping-mc.component.html'
})
export class ShoppingMCComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
